module.exports = __webpack_public_path__ + "img/full-savviform-1.0ccfc236.jpg";